import React, { useEffect, useRef } from "react";
import styles from "./TestimonialsSection.module.css";
import { Quote } from "lucide-react";
import { TESTIMONIALS_SECTION_CONTENT } from "../../Constants";

const TestimonialsSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add(styles.show);
        }
      },
      { threshold: 0.25 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className={styles.section}>
      <div className={styles.topLine}></div>

      <h2>{TESTIMONIALS_SECTION_CONTENT.heading}</h2>

      <div className={styles.cards}>
        {TESTIMONIALS_SECTION_CONTENT.testimonials.map((item, index) => (
          <div key={index} className={styles.card}>
            <p className={styles.quoteText}>“{item.text}”</p>

            <div className={styles.user}>
              <img src={item.img} alt={item.name} />
              <div className={styles.inner}>
                <h4>{item.name}</h4>
                <span>{item.role}</span>
              </div>
            </div>

            <div className={styles.quoteIcon}>
              <Quote size={22} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TestimonialsSection;